import type { Category } from "@nwt/norce-pwa/dist/runtime/types/api/category/category";
import type { BreadcrumbsCategory } from "~/types/composables/useCategoryTypes";

export const useCategory = () => {
	const getCategoryDetailsById = (
		categoryTree: Category[],
		id: number,
		keyToSearchFor: string
	) => {
		const findCategoryById: (categories: Category[]) => Category | null = (
			categories: Category[]
		) => {
			for (const category of categories) {
				if (category[keyToSearchFor as keyof typeof category] === id) {
					return category;
				}
				if (category.Children && category.Children.length) {
					const foundCategory: Category | null = findCategoryById(
						category.Children
					);
					if (foundCategory) return foundCategory;
				}
			}
			return null;
		};

		const getFullCategoryDetails = (
			categoryTree: Category[],
			category: Category | null
		) => {
			const categoryWithParent: BreadcrumbsCategory = JSON.parse(
				JSON.stringify(category)
			);
			if (category && category.ParentId) {
				const parentDetails = getCategoryDetailsById(
					categoryTree,
					category.ParentId,
					"Id"
				);
				if (parentDetails) {
					categoryWithParent.Parent = {
						Name: parentDetails.Name,
						Code: parentDetails.Code,
						Parent: parentDetails.Parent ? parentDetails.Parent : null
					};
				}
			}
			return categoryWithParent;
		};

		const category = findCategoryById(categoryTree || []);
		return getFullCategoryDetails(categoryTree, category);
	};

	const iterateOverCategoryDetails = (
		categoryDetails: BreadcrumbsCategory | Partial<BreadcrumbsCategory>,
		slugs: string[] = []
	) => {
		if (categoryDetails) {
			slugs.unshift(useNorcePwa().kebabCase(categoryDetails.Name!));
			if (categoryDetails.Parent) {
				iterateOverCategoryDetails(categoryDetails.Parent, slugs);
			}
		}
		return slugs.join("/");
	};

	const createCategoryLink = ({
		category
	}: {
		category: Pick<Category, "CategoryId">;
	}) => {
		const { locale } = useI18n();

		const categoryDetails = getCategoryDetailsById(
			useCategoryStore().getCategoryTree[locale.value]!,
			category.CategoryId,
			"CategoryId"
		);

		return iterateOverCategoryDetails(categoryDetails);
	};
	return {
		getCategoryDetailsById,
		createCategoryLink,
		iterateOverCategoryDetails
	};
};
